import { routes as invoices } from './Invoices';

export default [
  ...invoices,
]